import { render, staticRenderFns } from "./primary-item.vue?vue&type=template&id=6103e490&"
import script from "./primary-item.vue?vue&type=script&lang=js&"
export * from "./primary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports